import { render } from "./FiscalStatisticsHeader.vue?vue&type=template&id=830596c0&scoped=true"
import script from "./FiscalStatisticsHeader.vue?vue&type=script&lang=js"
export * from "./FiscalStatisticsHeader.vue?vue&type=script&lang=js"

import "./FiscalStatisticsHeader.vue?vue&type=style&index=0&id=830596c0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-830596c0"]])

export default __exports__